import { render, staticRenderFns } from "./NewsKeywordCloud.vue?vue&type=template&id=66988fd3"
import script from "./NewsKeywordCloud.vue?vue&type=script&lang=js"
export * from "./NewsKeywordCloud.vue?vue&type=script&lang=js"
import style0 from "./NewsKeywordCloud.vue?vue&type=style&index=0&id=66988fd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports